import React, { useState } from 'react';

const Test = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [indexing, setIndexing] = useState(-1);
  const [myName, setMyname] = useState([{ name: 'Preetham' }, { name: 'Vinay' }]);

  const handleChange = (e: any, index: number) => {
    const newArray = [...myName];
    newArray[index] = { ...newArray[index], name: e.target.value };
    setMyname(newArray);
  };
  return (
    <div className="bg-white h-screen w-full" onBlur={() => setIsEdit(false)}>
      {myName?.map((item: any, index: number) => {
        return (
          <div key={index}>
            {isEdit && index === indexing ? (
              <div className="bg-green-500">
                <input value={item.name} onChange={(e) => handleChange(e, index)} />
              </div>
            ) : (
              <div
                className="bg-red-500"
                onClick={() => {
                  setIsEdit(!isEdit);
                  setIndexing(index);
                }}
              >
                {item.name}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Test;
